package com.htmlagent.site.state

/**
 * Which pane the workspace is showing when there is only room for one.
 *
 * A closed set and not a boolean because it is a place the person is at, and the chat is the one
 * they land on: a session that has not produced anything yet has nothing else to show. Above
 * [com.htmlagent.site.theme.Breakpoints.Md] it does not apply at all - both panes are on screen.
 */
enum class WorkspacePane { CHAT, ARTIFACT }
